module.exports = __webpack_public_path__ + "static/img/5e67ff7b065f7c5f0e2dddbd31a6532c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_img4.png
// module id = kgfK
// module chunks = 1